import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const { Item } = Form;

const PasswordFormItem = ({
  message,
  fieldName,
  placeHolder,
  autoComplete,
}) => (
  <Item name={fieldName} rules={[{ required: true, message }]}>
    <Input.Password
      placeholder={placeHolder}
      autoComplete={autoComplete}
      prefix={<LockOutlined />}
    />
  </Item>
);

export default PasswordFormItem;
